import type { IconSvgObject } from './types';

const MoveThreeDIcon: IconSvgObject = [
  ["path", { d: "M5.9924 3L5.99201 11.9997C5.99188 14.8283 5.99182 16.2425 6.87051 17.1213C7.7492 18 9.16347 18 11.992 18H20.9924", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.992 17L13.992 10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.992 5.99998C8.992 5.99998 6.78254 3.00001 5.99198 3C5.20142 2.99999 2.992 6 2.992 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M17.992 21C17.992 21 20.992 18.7905 20.992 18C20.992 17.2094 17.992 15 17.992 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default MoveThreeDIcon;
